import { useFormContext } from '@hooks/react-hook-form';
import { Typography } from '@julo-ui/react';
import CloseIcon from '@new-components/shapes/CloseIcon';
import CashbackIcon from './assets/CashbackIcon';
import { appliedPromoCx } from './styles';

const AppliedPromo = () => {
  const { getValues, setValue } = useFormContext();

  return (
    <div className={appliedPromoCx}>
      <div className='left-side'>
        <CashbackIcon />
        <div>
          <Typography
            type='heading'
            headingType={6}
            bold
            fontSize='16px'
            q
            lineHeight='1.2'
          >
            {getValues('promoCodeMessage').title || 'Kamu mendapatkan promo'}
          </Typography>
          <Typography type='body' fontSize='12px' lineHeight='1.2'>
            {getValues('promoCodeMessage').description ||
              'Promo berhasil digunakan'}
          </Typography>
        </div>
      </div>
      <CloseIcon
        className='btn-close'
        onClick={() => {
          setValue('promoCode', '');
          setValue('promoCodeVerified', false);
        }}
      />
    </div>
  );
};

export default AppliedPromo;
